function SplashScreen() {
  return (
    <div className="h-screen bg-gradient-to-br rounded-md from-blue-600 to-indigo-600 flex justify-center flex-col items-center w-full">
      <img src="https://www.r-p-r.co.uk/newimages/rprfooter.png" />
    </div>
  );
}

export default SplashScreen;
